export const fr = {
  // Common
  "common.back": "Retour",
  "common.cancel": "Annuler",
  "common.noItems": "Aucun élément",
  "common.loading": "Chargement...",
  
  // Header
  "nav.features": "Fonctionnalités",
  "nav.howItWorks": "Comment ça marche",
  "nav.pricing": "Tarifs",
  "nav.faq": "FAQ",
  "nav.testimonials": "Vitrine",
  "nav.contact": "Contact",
  "button.getStarted": "Commencer",
  "button.loading": "Chargement...",

  // Auth related
  "auth.signIn": "Connexion",
  "auth.redirecting": "Redirection...",
  "auth.continueWithGoogle": "Continuer avec Google",
  "auth.continueWithGithub": "Continuer avec GitHub",
  "auth.or": "OU",
  "auth.consent.prefix": "En poursuivant, vous acceptez nos",
  "auth.consent.terms": "Conditions",
  "auth.consent.and": "et",
  "auth.consent.privacy": "Politique de Confidentialité",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜", // 中文标题

  // Hero Section
  "hero.title": "Assistant de Communication IA",
  "hero.subtitle": "Transformez vos conversations avec des réponses intelligentes et contextuelles qui vous aident à communiquer plus efficacement dans toute situation.",
  "hero.cta.primary": "Essai Gratuit",
  "hero.cta.secondary": "Voir la Démo",
  // New Hero Showcase keys
  "hero.cta.tryNow": "Commencer gratuitement",
  "hero.cta.learnMore": "En savoir plus",
  "hero.cta.getStarted": "Commencer gratuitement",
  "hero.preview.primary": "Polir le ton",
  "hero.preview.secondary": "Traduire",
  "hero.preview.tone": "Amical",
  "hero.preview.target": "Client",
  "hero.hook": "Rejoignez des milliers d'utilisateurs qui améliorent leur communication chaque jour.",
  // Stats
  "stats.users": "Utilisateurs",
  "stats.replies": "Réponses",
  "stats.languages": "Langues",

  // Main Title
  "main.title": "Transformez Chaque Réponse en Opportunité",

  // Footer Section - 新增
  "footer.company": "Entreprise",
  "footer.product": "Produit",
  "footer.support": "Support",
  "footer.legal": "Mentions Légales",
  "footer.contactSupport": "Contacter le Support",
  "footer.helpCenter": "Centre d'Aide",
  "footer.apiDocs": "Documentation API",
  "footer.statusPage": "État du Service",
  "footer.privacyPolicy": "Politique de Confidentialité",
  "footer.termsOfService": "Conditions d'Utilisation",
  "footer.cookiePolicy": "Politique de Cookies",
  "footer.refundPolicy": "Politique de Remboursement",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Support",

  // Features Section
  "features.badge": "Fonctionnalités Puissantes",
  "features.title": "Tout ce dont Vous Avez Besoin pour une Meilleure Communication",
  "features.subtitle": "Des outils complets conçus pour rendre chaque conversation plus efficace et professionnelle.",
  "features.scenario.title": "Modèles de Scénarios",
  "features.scenario.description": "Modèles pré-construits pour les communications professionnelles, personnelles, académiques et professionnelles.",
  "features.custom.title": "Entrées Personnalisées",
  "features.custom.description": "Collez n'importe quel message ou contenu et obtenez des réponses contextuellement appropriées.",
  "features.instant.title": "Réduire le temps de réponse de 90%",
  "features.instant.description": "Obtenez des réponses élaborées par l'IA en quelques secondes. Pas d'attente, que des résultats.",
  "features.copy.title": "Copier et Partager en Un Clic",
  "features.copy.description": "Copiez les réponses instantanément ou partagez-les directement depuis la plateforme.",

  // How It Works Section
  "howItWorks.badge": "Comment ça marche",
  "howItWorks.title": "Trois Étapes Simples pour une Meilleure Communication",
  "howItWorks.subtitle": "Notre processus simplifié facilite la génération de réponses professionnelles pour toute situation.",
  "howItWorks.step1.title": "Sélectionner le Scénario",
  "howItWorks.step1.description": "Choisissez le scénario de communication qui correspond le mieux à vos besoins.",
  "howItWorks.step2.title": "Coller le Contenu",
  "howItWorks.step2.description": "Ajoutez le message ou le contenu auquel vous devez répondre.",
  "howItWorks.step3.title": "Obtenir la Réponse IA",
  "howItWorks.step3.description": "Recevez une réponse professionnelle et contextuelle en quelques secondes.",

  // Pricing Section
  "pricing.title": "Tarifs",
  "pricing.subtitle": "Choisissez le plan qui correspond à vos besoins de communication",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/mois",
  "pricing.free.description": "Parfait pour essayer notre service",
  "pricing.pro.description": "Idéal pour les professionnels et utilisateurs fréquents",
  "pricing.business.description": "Pour les équipes et organisations",
  "pricing.popular": "Le Plus Populaire",
  "pricing.free.feature1": "10 réponses par mois",
  "pricing.free.feature2": "Scénarios de base",
  "pricing.free.feature3": "Définir et utiliser des modèles",
  "pricing.free.feature4": "Historique des réponses",
  "pricing.pro.feature1": "200 réponses par mois",
  "pricing.pro.feature2": "Scénario de base + personnalisé",
  "pricing.pro.feature3": "Définir et utiliser des modèles",
  "pricing.pro.feature4": "Historique des réponses",
  "pricing.pro.feature5": "Personnalisation avancée",
  "pricing.business.feature1": "Réponses illimitées",
  "pricing.business.feature2": "Collaboration d'équipe",
  "pricing.business.feature3": "Scénario de base + personnalisé",
  "pricing.business.feature4": "Définir et utiliser des modèles",
  "pricing.business.feature5": "Historique des réponses",
  "pricing.business.feature6": "Personnalisation avancée",
  "pricing.cta.trial": "Commencer l'Essai Gratuit",
  "pricing.cta.subscribe": "S'abonner",
  "pricing.cta.contact": "Contacter les Ventes",
  "pricing.cta.current": "Plan Actuel",
  "pricing.currentPlan": "Plan Actuel:",
  "pricing.endDate": "Date de fin du plan actuel:",
  "pricing.autoRenewalDate": "Date de renouvellement automatique du plan actuel:",
  "pricing.answersLeft": "Réponses restantes:",
  "pricing.planName.free": "Free Plan",
  "pricing.planName.proMonthly": "Pro Plan-Mensuel",
  "pricing.planName.proYearly": "Pro Plan-Annuel",
  "pricing.planName.maxMonthly": "Enterprise Plan-Mensuel",
  "pricing.planName.maxYearly": "Enterprise Plan-Annuel",
  "pricing.autoRenews": "Votre nombre de réponses se renouvelle automatiquement le:",
  "pricing.needMore": "Besoin de plus de réponses?",
  "pricing.upgradeBelow": "Mettez à niveau votre plan ci-dessous",
  "pricing.doNotRollOver": "Les réponses inutilisées ne se reportent pas",
  "pricing.willCancelOn": "Sera annulé le:",
  "pricing.downgradeScheduled": "Rétrogradation prévue. Passera à",
  "pricing.on": "le:",
  "pricing.upgradeImmediateTitle": "Plan mis à niveau",
  "pricing.upgradeImmediateDesc": "Votre nouveau plan est maintenant actif.",
  "pricing.downgradeScheduledTitle": "Rétrogradation prévue",
  "pricing.downgradeScheduledDesc": "Votre plan changera au prochain renouvellement.",
  "pricing.cancelScheduledTitle": "Annulation prévue",
  "pricing.cancelScheduledDesc": "Votre plan se terminera à la date de fin de période.",
  "pricing.cancelResumedTitle": "Annulation supprimée",
  "pricing.cancelResumedDesc": "Votre abonnement continuera à se renouveler.",
  "pricing.cancelPendingDowngrade": "Annuler",
  "pricing.pendingDowngradeCanceledTitle": "Rétrogradation en attente annulée",
  "pricing.pendingDowngradeCanceledDesc": "Votre plan restera inchangé.",
  "pricing.pendingDowngradeCancelFailedTitle": "Échec de l'annulation",
  "pricing.pendingDowngradeCancelFailedDesc": "Impossible d'annuler la rétrogradation en attente. Veuillez réessayer.",
  "pricing.cancelPendingDowngradeProcessing": "Traitement...",
  "pricing.scheduled": "Prévu",
  "pricing.processing": "Traitement...",
  "pricing.getMoreReplies": "Obtenir plus de réponses",
  "pricing.oneTimeTitle": "Obtenir plus de réponses pour votre compte",
  "pricing.oneTimeAmountLabel": "Montant (USD)",
  "pricing.repliesUnit": "Réponses",
  "pricing.oneTimeNotice": "Le nombre de réponses que vous achetez est valable pour le cycle mensuel en cours. Un abonnement payant actif est requis pour les utiliser et les réponses inutilisées ne se reportent pas.",
  "pricing.cancel": "Annuler",
  "pricing.proceed": "Procéder",
  "pricing.confirmUpgradeTitle": "Confirmer la mise à niveau",
  "pricing.confirmDowngradeTitle": "Confirmer la rétrogradation",
  "pricing.confirmUpgradeDesc": "Vous êtes sur le point de mettre à niveau votre plan. Le changement prend effet immédiatement et une charge (ou un crédit) au prorata peut s'appliquer.",
  "pricing.confirmDowngradeDesc": "Vous êtes sur le point de programmer une rétrogradation. Vos fonctionnalités actuelles restent jusqu'à la fin de la période de facturation en cours.",
  "pricing.downgradeEffectNote": "La rétrogradation ne rembourse pas le cycle en cours.",
  "pricing.downgradeApplyNextCycle": "Le nouveau plan démarrera automatiquement au renouvellement.",
  "pricing.confirmCancel": "Retour",
  "pricing.confirmProceedUpgrade": "Mettre à niveau maintenant",
  "pricing.confirmProceedDowngrade": "Programmer la rétrogradation",

  // FAQ Section
  "faq.title": "Questions Fréquemment Posées",
  "faq.subtitle": "Tout ce que vous devez savoir sur communicate2win",
  "faq.q1": "Quels scénarios de communication sont pris en charge ?",
  "faq.a1": "Nous prenons en charge les communications professionnelles, les relations personnelles, la correspondance académique, le service client, la prospection commerciale et de nombreux autres scénarios. Notre IA s'adapte au contexte et au ton requis pour chaque situation.",
  "faq.q2": "À quelle vitesse les réponses sont-elles générées ?",
  "faq.a2": "Notre IA génère des réponses en quelques secondes. Nous priorisons la vitesse sans compromettre la qualité, garantissant que vous obtenez des réponses professionnelles instantanément.",
  "faq.q3": "Puis-je annuler mon abonnement à tout moment ?",
  "faq.a3": "Oui, vous pouvez annuler votre abonnement à tout moment. Il n'y a pas d'engagements à long terme, et vous pouvez rétrograder ou mettre à niveau votre plan selon vos besoins.",
  "faq.q4": "Mes données sont-elles sécurisées et privées ?",
  "faq.a4": "Oui, nous mettons en œuvre des mesures de sécurité complètes incluant le chiffrement, les contrôles d'accès et des audits de sécurité réguliers. Votre contenu d'entrée et les réponses générées sont stockés dans votre historique utilisateur pour activer des fonctionnalités comme la révision des réponses et la création de modèles. Vous pouvez supprimer vos données d'historique à tout moment via les paramètres de votre compte.",
  "faq.q5": "Que se passe-t-il si j'épuise mes Replies ?",
  "faq.a5": "Les utilisateurs Free doivent attendre le prochain cycle mensuel pour le renouvellement de leur quota. Après passage à Pro, s'ils manquent de Replies ils peuvent acheter des Replies ponctuelles supplémentaires ; ces Replies supplémentaires ne sont valables que pour le cycle mensuel en cours. Les utilisateurs Enterprise disposent de Replies illimitées.",
  "faq.q6": "Quelles langues sont prises en charge ?",
  "faq.a6": "Actuellement, nous prenons en charge l'anglais avec des plans d'expansion vers l'espagnol, le français, l'allemand et d'autres langues principales. L'IA peut gérer efficacement les communications multilingues.",
  "testimonials.title": "Vitrine de Communication",
  "testimonials.subtitle": "Messages publics, e-mails et réponses optimisées par l'IA pour inspirer les vôtres",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Directrice Marketing",
  "testimonials.sarah.quote": "communicate2win a transformé ma façon de gérer les communications clients. Les réponses sont professionnelles et me font économiser des heures chaque semaine.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Responsable des Ventes",
  "testimonials.michael.quote": "Les modèles de scénarios professionnels sont incroyablement précis. Mon taux de réponse s'est amélioré de 40% depuis que j'utilise cet outil.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Responsable du Succès Client",
  "testimonials.emily.quote": "Parfait pour gérer les situations clients difficiles. L'IA comprend parfaitement le contexte et le ton.",
  "testimonials.more": "Cliquez sur la galerie pour explorer toute la vitrine",

  // Interface Elements
  "interface.generating": "Génération de la Réponse...",
  "interface.generate": "Générer une Réponse IA",
  "interface.processing": "Traitement...",
  "interface.advancedOptions": "Options Avancées",
  "interface.clearInput": "Effacer l'entrée",
  "interface.clearDescription": "Effacer la description",
  // Marquee / Logos
  "marquee.trusted": "Partenaires / Support",
  "marquee.aria": "Logos de marques",

  // History and Showcase
  "history.shareToShowcase": "Partager dans la Vitrine",
  "history.showcased": "Ajouté à la vitrine",
  "history.shareConfirm": "Confirmer le partage dans la Vitrine? Cette action est irréversible, sauf si vous supprimez le contenu.",
  "history.sharedBy": "Partagé par:",
  "interface.copy": "Copier",
  "interface.share": "Partager",
  "interface.shareResponse": "Partager la Réponse",
  "interface.shareNative": "Partager par Système",
  "interface.shareEmail": "Email",
  "interface.copyShareText": "Copier avec Lien",
  "interface.shareTextCopied": "Réponse et lien copiés dans le presse-papiers.",
  "interface.ready": "Prêt à Générer",
  "interface.enterMessage": "Entrez le contenu de votre message et sélectionnez un scénario pour commencer avec des réponses alimentées par l'IA.",
  "interface.fast": "Rapide",
  "interface.accurate": "Précis",
  "interface.professional": "Professionnel",
  "interface.translation": "Traduction",
  "interface.responseDescription": "Voici une réponse réfléchie et professionnelle adaptée au contexte :",
  "interface.multipleOptions": "Plusieurs options de réponse :",
  "interface.option": "Option",
  "interface.noContent": "Aucun contenu disponible",

  // Placeholders
  "placeholder.message": "Collez le message auquel vous répondez, le contenu de l'e-mail ou le texte que vous avez reçu...",

  // Dropdowns
  "dropdown.useTemplates": "Utiliser des modèles",
  "dropdown.scenario": "Aucun Scénario",
  "dropdown.target": "Aucune Cible",
  "dropdown.tone": "Aucun Ton",

  // Scenario Options
  "scenario.email": "Email",
  "scenario.message": "Message",
  "scenario.workplace": "Travail",
  "scenario.school": "École",
  "scenario.home": "Maison",
  "scenario.business": "Affaires",
  "scenario.academic": "Académique",
  "scenario.social": "Social",
  "scenario.formal": "Formel",
  "scenario.casual": "Décontracté",
  "scenario.professional": "Professionnel",
  "scenario.personal": "Personnel",
  "scenario.customerService": "Service Client",
  "scenario.interview": "Entretien",
  "scenario.presentation": "Présentation",

  // Target Options
  "target.lover": "Amoureux",
  "target.friend": "Ami",
  "target.boss": "Patron",
  "target.colleague": "Collègue",
  "target.classmate": "Camarade de classe",
  "target.parents": "Parents",
  "target.child": "Enfant",
  "target.teacher": "Professeur",
  "target.student": "Étudiant",
  "target.client": "Client",
  "target.customer": "Client",
  "target.stranger": "Inconnu",
  "target.family": "Famille",
  "target.sibling": "Frère/Sœur",
  "target.neighbor": "Voisin",
  "target.mentor": "Mentor",
  "target.supplier": "Fournisseur",
  "target.serviceProvider": "Prestataire de Services",
  "target.partner": "Partenaire",
  "target.subordinate": "Subordonné",

  // Tone Options
  "tone.humorous": "Humoristique",
  "tone.serious": "Sérieux",
  "tone.happy": "Joyeux",
  "tone.angry": "En colère",
  "tone.mischievous": "Espiègle",
  "tone.polite": "Poli",
  "tone.casual": "Décontracté",
  "tone.formal": "Formel",
  "tone.friendly": "Amical",
  "tone.confident": "Confiant",
  "tone.apologetic": "Excuses",
  "tone.enthusiastic": "Enthousiaste",

  // Status Messages
  "status.copied": "Copié !",
  "status.copyDescription": "Réponse copiée dans le presse-papiers.",
  "status.copyWithTranslationDescription": "Réponse et traduction copiées dans le presse-papiers.",
  "status.success": "Réponse générée avec succès. ",
  "status.successWithTranslation": "Réponse générée avec traduction.",
  "status.successWithoutTranslation": "Réponse générée avec succès.",
  "status.error": "Échec de la génération",
  "status.errorDescription": "Échec de la génération de la réponse. Veuillez réessayer.",
  "status.enterContent": "Veuillez entrer du contenu",
  "status.enterContentDescription": "Ajoutez le message auquel vous voulez répondre.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Description (optionnelle)",
  "restriction.descriptionLabel": "Description (Uniquement pour les abonnés Pro / Enterprise)",
  "restriction.proMaxOnly": "* Uniquement pour les abonnés Pro / Enterprise",
  "restriction.desPrompt": "Saisissez le contexte, les informations de fond ou les exigences spécifiques afin de produire de meilleures réponses...",

  // Demo functionality for non-logged-in users
  "demo.title": "Sélectionnez un message auquel répondre",
  "demo.option1": "Ouverture commerciale (approche à froid)",
  "demo.option2": "Gérer une sonde \"votre prix est élevé\"",
  "demo.option3": "Auto-présentation d'entretien (version 30 secondes)",
  "demo.option4": "Réponse par e-mail",
  "demo.option5": "Suivi pour un prospect \"lu mais pas de réponse\"",
  "demo.option6": "Pitch d'ascenseur (30 secondes)",
  "demo.runDemo": "Lancer la Démo",
  "demo.inputContent": "Contenu d'Entrée :",
  "demo.scenario": "Scénario :",
  "demo.target": "Cible :",
  "demo.tone": "Ton :",
  "demo.description": "Description :",

  // Showcase Page
  "showcase.title": "Vitrine de Communication",
  "showcase.subtitle": "Découvrez des communications inspirantes optimisées par l'IA partagées par notre communauté",
  "showcase.userPrefix": "Communications publiques par",
  "showcase.backAll": "Retour à toute la Vitrine",
  "showcase.sortBy": "Trier par :",
  "showcase.sort.newest": "Plus récent d'abord",
  "showcase.sort.oldest": "Plus ancien d'abord",
  "showcase.sort.scenario": "Par Scénario",
  "showcase.sort.target": "Par Cible",
  "showcase.sort.tone": "Par Ton",
  "showcase.filter.scenario": "Scénario :",
  "showcase.filter.target": "Cible :",
  "showcase.filter.tone": "Ton :",
  "showcase.filter.all": "Tous",
  "showcase.loading": "Chargement de la vitrine...",
  "showcase.loadingUser": "Chargement des communications de l'utilisateur...",
  "showcase.loadingMore": "Chargement supplémentaire...",
  "showcase.none.userTitle": "Aucune communication publique pour le moment",
  "showcase.none.globalTitle": "Aucun élément dans la vitrine pour le moment",
  "showcase.none.userDesc": "Cet utilisateur n'a pas encore partagé de communications dans la vitrine.",
  "showcase.none.globalDesc": "Soyez le premier à partager votre communication IA dans la vitrine !",
  "showcase.messageDetails": "Détails du Message",
  "showcase.field.date": "Date",
  "showcase.field.scenario": "Scénario",
  "showcase.field.target": "Cible",
  "showcase.field.tone": "Ton",
  "showcase.originalMessage": "Message Original",
  "showcase.description": "Description",
  "showcase.aiResponse": "Réponse IA",

  // Templates
  "templates.saveAsTemplate": "Enregistrer comme Modèle",
  "templates.saved": "Modèle Enregistré",
  "templates.saveSuccess": "Modèle enregistré avec succès",
  "templates.title": "Mes Modèles",
  "templates.new": "Nouveau Modèle",
  "templates.loading": "Chargement...",
  "templates.none": "Aucun modèle trouvé",
  "templates.name": "Nom",
  "templates.scenario": "Scénario",
  "templates.target": "Cible",
  "templates.tone": "Ton",
  "templates.description": "Description",
  "templates.save": "Enregistrer",
  "templates.saving": "Enregistrement...",
  "templates.delete": "Supprimer le Modèle",
  "templates.deleteConfirm": "Supprimer ce modèle ?",
  "templates.deleteFailed": "Échec de la suppression du modèle",
  "templates.nameRequired": "* Veuillez entrer un nom de modèle",
  "templates.deleteSuccess": "Modèle supprimé avec succès",

  // History Modal additions
  "history.messageDetails": "Détails du Message",
  "history.messageDetailsDesc": "Afficher et gérer les détails du message, y compris l'entrée originale et la réponse générée par l'IA.",
  "history.field.date": "Date",
  "history.field.scenario": "Scénario",
  "history.field.target": "Cible",
  "history.field.tone": "Ton",
  "history.originalMessage": "Message Original",
  "history.aiResponse": "Réponse IA",
  "history.description": "Description",
  "history.listTitle": "Historique des Messages",
  "history.listDesc": "Parcourir, filtrer et gérer votre historique de conversation. Cliquez sur n'importe quel message pour afficher les détails.",
  "history.sortBy": "Trier par :",
  "history.sort.newest": "Plus récent d'abord",
  "history.sort.oldest": "Plus ancien d'abord",
  "history.sort.scenario": "Par Scénario",
  "history.sort.target": "Par Cible",
  "history.sort.tone": "Par Ton",
  "history.filter.scenario": "Scénario :",
  "history.filter.target": "Cible :",
  "history.filter.tone": "Ton :",
  "history.filter.all": "Tous",
  "history.loading": "Chargement de l'historique...",
  "history.loadingMore": "Chargement supplémentaire...",
  "history.none": "Aucun message trouvé",
  "history.showing": "Affichage de {current} sur {total} messages",
  "history.allLoaded": "Tous les messages chargés",
  "history.scrollMore": "Faites défiler vers le bas pour en voir plus",
  "history.loadMoreButton": "Charger Plus",
  "history.deleteMessage": "Supprimer le Message",
  "history.deleting": "Suppression...",
  "history.deleteSuccess": "Enregistrement du message supprimé avec succès",
  "history.deleteFailed": "Échec de la suppression de l'enregistrement du message, veuillez réessayer",
  "history.confirmDeleteTitle": "Confirmer la Suppression",
  "history.confirmDeleteSubtitle": "Cette action ne peut pas être annulée",
  "history.confirmDeleteDesc": "Êtes-vous sûr de vouloir supprimer cet enregistrement de message ?",
  "history.confirmDeleteAction": "Confirmer la Suppression",
  "history.shareTitle": "Partager dans la Vitrine",
  "history.shareSubtitle": "Rendre ce message public",
  "history.sharing": "Partage...",
  "history.confirmShareAction": "Confirmer le Partage",
  "history.shareSuccess": "Message partagé dans la vitrine avec succès",
  "history.shareFailed": "Échec du partage dans la vitrine, veuillez réessayer",
  "templates.saveFailed": "Échec de l'enregistrement du modèle",

  // User Menu
  "userMenu.myAccount": "Mon Compte",
  "userMenu.history": "Historique",
  "userMenu.templates": "Modèles",
  "userMenu.signOut": "Se Déconnecter",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "Aperçu de la Réponse IA",
  "hero.preview.scenarioLabel": "Scénario",
  "hero.headline": "Assistant de Communication IA",
  "hero.subheadline": "Transformez des idées brutes en réponses polies et contextuelles en quelques secondes.",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Ouverture commerciale",
  "demo.shortTitle.priceObjection": "Sonde de prix",
  "demo.shortTitle.interviewIntro": "Intro d'entretien",
  "demo.shortTitle.emailReply": "Réponse email",
  "demo.shortTitle.followUp": "Suivi",
  "demo.shortTitle.elevatorPitch": "Pitch d'ascenseur",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "réponse",
  "demoTabs.inputPrompt": "ENTRÉE",
  "demoTabs.context": "CONTEXTE",
  "demoTabs.description": "Description",
  "demoTabs.generate": "Générer",
  "demoTabs.aiOutput": "SORTIE IA",
  "demoTabs.sample": "échantillon",
  "demoTabs.streaming": "Diffusion de jetons...",
  "preview.section.scenarioTemplates.title": "Scénario & Modèles",
  "preview.section.scenarioTemplates.subtitle": "Choisissez rapidement un scénario ou appliquez un modèle enregistré. Les modèles préremplissent la description / cible / ton pour une génération de haute qualité instantanée.",
  "preview.section.customInputs.title": "Entrées Personnalisées",
  "preview.section.customInputs.subtitle": "Entrée principale + description optionnelle + sélecteurs avancés Scénario / Cible / Ton. Combinez librement pour des résultats contextuels.",
  "preview.section.cutReplyTime.title": "Réduire le Temps de Réponse de 90%",
  "preview.section.cutReplyTime.subtitle": "Comparez la rédaction manuelle vs l'assistance IA. Options parallèles + boucles de traduction/révision intégrées.",
  "preview.section.copyShare.title": "Copier et Partager en Un Clic",
  "preview.section.copyShare.subtitle": "Plusieurs options disposées avec actions unifiées en haut : tout copier / partager / copie par option. Traduction ajoutée automatiquement.",
  "preview.templates.my": "Mes Modèles",
  "preview.templates.new": "Nouveau",
  "preview.manualFlow": "Flux Manuel",
  "preview.aiAssisted": "Assisté par IA",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Planifier la structure & le ton",
  "preview.manualFlow.step2": "Rédiger l'ouverture / supprimer & réécrire",
  "preview.manualFlow.step3": "Ajuster la politesse & la grammaire",
  "preview.manualFlow.step4": "Rechercher le libellé + vérifier la traduction",
  "preview.manualFlow.step5": "Coller dans l'application cible",
  "preview.copyAll": "Tout Copier",
  "preview.share": "Partager",
  "preview.enPlusTranslation": "EN + Traduction",
  "preview.translationAppendNote": "(*) La traduction est ajoutée automatiquement lors de la copie complète.",
  "preview.field.scenario": "Scénario",
  "preview.field.target": "Cible",
  "preview.field.tone": "Ton",
  "preview.auto": "Auto",
  "preview.step.pasteOrTemplate": "Coller la demande ou choisir un modèle",
  "preview.step.optionalDescription": "(Optionnel) ajouter description / scénario",
  "preview.step.pickOption": "Choisir une option générée",
  "preview.step.copyShareTranslate": "Copie / partage / traduction en un clic",
  "preview.time.manual": "5–8 min",
  "preview.time.ai": "30–40 sec"
};